import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs'; 
import { ComprobanteDto } from '../models/comp.dto';

@Injectable({
  providedIn: 'root'
})
export class CompService {
  private apiUrl = ``;
  private entity = `comp`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }


  getAll(): Observable<ComprobanteDto[]> {
    return this.http.get<ComprobanteDto[]>(this.apiUrl);
  }

}
